import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'bt-order-approve-modal',
	standalone: false,
	templateUrl: './order-approve-modal.component.html',
	styleUrl: './order-approve-modal.component.scss'
})
export class OrderApproveModalComponent {
	data = inject<any>(MAT_DIALOG_DATA);
	loading = false;
	isDragging = false;

	constructor(private dialogRef: MatDialogRef<OrderApproveModalComponent>) {}

	close(): void {
		this.dialogRef.close();
	}
}
